import {
  displayValueWithMultiplier,
  displayDisplacementWithMultiplier
} from '../format';
import {
  RTG_ABNORMAL_CATEGORY_VALUES,
  RTG_NORMAL_CATEGORY_VALUES,
  DER_TYPES,
  UNIT_STRINGS
} from '../appConstants';

export const DerCapabilitySchema = {
  derId: {
    // no toDisplayString, since it will not be displayed.
  },
  modesSupported: {
    // no toDisplayString, since it will not be displayed.
  },
  rtgAbnormalCategory: {
    toDisplayString: value => RTG_ABNORMAL_CATEGORY_VALUES[value]
  },
  rtgMaxA: {
    displayUnits: UNIT_STRINGS.CURRENT_RMS,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  rtgMaxAh: {
    displayUnits: UNIT_STRINGS.AMP_HOURS,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  rtgMaxChargeRateVA: {
    displayUnits: UNIT_STRINGS.APPARENT_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  rtgMaxChargeRateW: {
    displayUnits: UNIT_STRINGS.ACTIVE_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  rtgMaxDischargeRateVA: {
    displayUnits: UNIT_STRINGS.APPARENT_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  rtgMaxDischargeRateW: {
    displayUnits: UNIT_STRINGS.ACTIVE_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  rtgMaxV: {
    displayUnits: UNIT_STRINGS.VOLTAGE_RMS,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  rtgMaxVA: {
    displayUnits: UNIT_STRINGS.APPARENT_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  rtgMaxVar: {
    displayUnits: UNIT_STRINGS.REACTIVE_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  rtgMaxVarNeg: {
    displayUnits: UNIT_STRINGS.REACTIVE_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  rtgMaxW: {
    displayUnits: UNIT_STRINGS.ACTIVE_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  rtgMaxWh: {
    displayUnits: UNIT_STRINGS.WATT_HOURS,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  rtgMinPFOverExcited: {
    displayUnits: UNIT_STRINGS.POWER_FACTOR,
    powerOfTen: 0,
    toDisplayString: displayDisplacementWithMultiplier
  },
  rtgMinPFUnderExcited: {
    displayUnits: UNIT_STRINGS.POWER_FACTOR,
    powerOfTen: 0,
    toDisplayString: displayDisplacementWithMultiplier
  },
  rtgMinV: {
    displayUnits: UNIT_STRINGS.VOLTAGE_RMS,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  rtgNormalCategory: {
    toDisplayString: value => RTG_NORMAL_CATEGORY_VALUES[value]
  },
  rtgOverExcitedPF: {
    displayUnits: UNIT_STRINGS.POWER_FACTOR,
    powerOfTen: 0,
    toDisplayString: displayDisplacementWithMultiplier
  },
  rtgOverExcitedW: {
    displayUnits: UNIT_STRINGS.ACTIVE_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  rtgReactiveSusceptance: {
    displayUnits: '',
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  rtgUnderExcitedPF: {
    displayUnits: UNIT_STRINGS.POWER_FACTOR,
    powerOfTen: 0,
    toDisplayString: displayDisplacementWithMultiplier
  },
  rtgUnderExcitedW: {
    displayUnits: UNIT_STRINGS.ACTIVE_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  rtgVNom: {
    displayUnits: UNIT_STRINGS.VOLTAGE_RMS,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  type: {
    toDisplayString: value => DER_TYPES[value]
  }
};
